//Constants
import * as ACTIONS from './actionTypes';

//Types
import { ActionGetSSOTokenSuccess } from './actions';

export interface AdvancedLmState {
    ssoToken?: string;
    error?: any;
    showInfoHeader?: boolean;
}

const defaultState: AdvancedLmState = {
    ssoToken: undefined,
    error: undefined,
    showInfoHeader: true
};

type AdvancedLmAction = ActionGetSSOTokenSuccess;

function advancedLm(state: AdvancedLmState = defaultState, action: AdvancedLmAction): AdvancedLmState {
    switch (action.type) {
        case ACTIONS.GET_CHATMETER_SSO_TOKEN_SUCCESS:
            {
                return {
                    ...state,
                    ssoToken: action.ssoToken
                }
            }
        case ACTIONS.GET_CHATMETER_SSO_TOKEN_ERROR:
            {
                return {
                    ...state,
                    error: action.error
                }
            }
        case ACTIONS.SHOW_INFO_HEADER:
                {
                    return {
                        ...state,
                        showInfoHeader: action.showInfoHeader
                    }
                }
    }
    return {
        ...state
    }
}

export default advancedLm;